export var ETOROBET_DEFAULT_VALUES = {
    contactEmail: "matthias@wisegaming.com",
    userDetailsUrl: "https://callback-management.int.wisegaming.com/api/wisecasinointegrationmanagement/v1/userDetails",
    transactionUrl: "https://callback-management.int.wisegaming.com/api/wisecasinointegrationmanagement/v1/transactions",
    skinCode: "wise",
    maxNumofTables: 100,
    tenant: "etorobet",
    note: "This operator is a global lobby. Max Num of Tables represents maximum number of active tables for this operator lobby before creating a new one.",
    getBalanceUrl: "https://callback-management.int.wisegaming.com/api/wisecasinointegrationmanagement/v1/getBalance",
    lobbyUrl: "https://int.pokerwise.io",
    enabledGameTypes: ["texasholdem"],
};
